export const FETCH_BERBIX_TOKEN_REQUEST = "BERBIX/FETCH_TOKEN_REQUEST";
export const FETCH_BERBIX_TOKEN_ERROR = "BERBIX/FETCH_TOKEN_ERROR";
export const FETCH_BERBIX_TOKEN_SUCCESS = "BERBIX/FETCH_TOKEN_SUCCESS";

export const FETCH_BERBIX_REQUEST_REQUEST = "BERBIX/FETCH_REQUEST_REQUEST";
export const FETCH_BERBIX_REQUEST_ERROR = "BERBIX/FETCH_REQUEST_ERROR";
export const FETCH_BERBIX_REQUEST_SUCCESS = "BERBIX/FETCH_REQUEST_SUCCESS";
